// What a place looks like in a list you choose places from (2026-10-17):
// photo, category and visit length, the first sentence of its notes, and
// whether it's a must-see. Built only from what the place holds — nothing is
// looked up. Used by PlacesReviewModal (Build My Trip) and by
// MultiSelectModal rows that carry `placeRow` (event place picker, Places
// menu actions, Walk with AI).

import Common from "./Common";

// The place's notes as text: no tags, no "See more" link, collapsed spaces.
export const notesText = (html) => {
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = String(html).replace(/<a[^>]*>\s*\.{3}\s*See More\.?\s*<\/a>/gi, "");
  return (div.textContent || "").replace(/\s+/g, " ").trim();
};

export const firstSentence = (text) => {
  const m = String(text || "").match(/^(.{20,180}?[.!?])(\s|$)/);
  return m ? m[1] : text.length > 140 ? `${text.slice(0, 140).trim()}…` : text;
};

export const visitLengthLabel = (minutes) => {
  const m = Number(minutes);
  if (!Number.isFinite(m) || m <= 0) return "";
  if (m < 60) return `~${Math.round(m / 5) * 5} min`;
  const h = Math.floor(m / 60), rest = Math.round((m % 60) / 15) * 15;
  return rest ? `~${h} h ${rest}` : `~${h} h`;
};

export const placeCategoryName = (place, categories) => {
  const byId = new Map((categories || []).map((c) => [String(c.id), c.name]));
  const names = (place?.Category || []).map((id) => byId.get(String(id))).filter(Boolean);
  return names.find((n) => n !== "Attraction") || names[0] || "";
};

export const placePhotoURL = (place, user_info) => {
  const src = place?.Photo || place?.Photo_m; // a small row: the thumbnail first, as on mobile (2026-11-04)
  if (!src) return "";
  try {
    return Common.getImageURL(src, Common.getFBPath(window.guide_obj?.guide_id, user_info || {}), false);
  } catch (e) {
    return src;
  }
};

// { thumb, meta, desc, fullDesc, star } for a list row.
export const placeRowFor = (place, { categories, user_info } = {}) => {
  if (!place) return null;
  const fullDesc = notesText(place.Info);
  return {
    thumb: placePhotoURL(place, user_info),
    meta: [placeCategoryName(place, categories), visitLengthLabel(place.Duration)].filter(Boolean).join(" · "),
    desc: fullDesc ? firstSentence(fullDesc) : "",
    fullDesc,
    star: !!place.MustSee,
  };
};
